import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { get, isEqual } from 'lodash';
import {
    EDIT_PAYMENT_ROUTING_FAILURE,
    EDIT_PAYMENT_ROUTING_LOAD,
    EDIT_PAYMENT_ROUTING_SUCCESS,
    PAYMENT_ROUTING_FAILURE,
    PAYMENT_ROUTING_LOAD,
    PAYMENT_ROUTING_SUCCESS
} from './paymentRoutingActions';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case EDIT_PAYMENT_ROUTING_FAILURE:
            newState = {
                ...state,
                editPaymentRoutingError: action.error,
                isEditPaymentRoutingLoading: false,
                isPaymentRoutingLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        case EDIT_PAYMENT_ROUTING_LOAD:

            newState = {
                ...state,
                editPaymentRoutingError: null,
                isEditPaymentRoutingLoading: true,
                isEditPaymentRoutingSuccessful: false,
                isPaymentRoutingLoaded: false
            };

            return isEqual(state, newState) ? state : newState;

        case EDIT_PAYMENT_ROUTING_SUCCESS:
            newState = {
                ...state,
                isEditPaymentRoutingLoading: false,
                isEditPaymentRoutingSuccessful: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYMENT_ROUTING_LOAD:
            newState = {
                ...state,
                isPaymentRoutingLoading: true,
                isPaymentRoutingLoaded: false
            };

            return isEqual(state, newState) ? state : newState;

        case PAYMENT_ROUTING_SUCCESS:
            newState = {
                ...state,
                count: action.count,
                pages: action.pages,
                rules: action.rules,
                isPaymentRoutingLoading: false,
                isPaymentRoutingLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        case PAYMENT_ROUTING_FAILURE:
            newState = {
                ...state,
                count: 0,
                isPaymentRoutingLoading: false,
                pages: 0,
                rules: [],
                isPaymentRoutingLoaded: true
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getPaymentRoutingEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'paymentRouting')
);

export const getIsEditPaymentRoutingLoading = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'isEditPaymentRoutingLoading')
);

export const getIsEditPaymentRoutingSuccessful = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'isEditPaymentRoutingSuccessful')
);

export const getEditPaymentRoutingError = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'editPaymentRoutingError')
);

export const getEditPaymentRoutingErrorMessage = createSelector(
    getEditPaymentRoutingError,
    (error) => get(error, 'message')
);

export const getCount = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'count')
);

export const getPages = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'pages')
);

export const getPaymentRouting = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'rules')
);

export const getIsPaymentRoutingLoading = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'isPaymentRoutingLoading')
);

export const getIsPaymentRoutingLoaded = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'isPaymentRoutingLoaded')
);

export const getPaymentRoutingError = createSelector(
    getPaymentRoutingEntity,
    (entity) => get(entity, 'paymentRoutingError')
);

export const getPaymentRoutingErrorMessage = createSelector(
    getPaymentRoutingError,
    (error) => get(error, 'message')
);
